import { render, staticRenderFns } from "./Subsidiaries.vue?vue&type=template&id=69c23d5e&scoped=true"
import script from "./Subsidiaries.vue?vue&type=script&lang=js"
export * from "./Subsidiaries.vue?vue&type=script&lang=js"
import style0 from "./Subsidiaries.vue?vue&type=style&index=0&id=69c23d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c23d5e",
  null
  
)

export default component.exports